import type { TourSection } from './types';

export const usersListSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Buscar usuarios',
    steps: [
      {
        target: '[data-tour="users-filters"]',
        title: 'Búsqueda',
        content:
          'Busca por nombre o email, o filtra por quienes tienen acceso y quienes no. Esta lista es la de las personas que tienen o tuvieron acceso al PIM en Effetá Apps.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado',
    steps: [
      {
        target: '[data-tour="users-table"]',
        title: 'Tabla',
        content:
          'Foto, nombre, email, rol y si tiene acceso. Con "Editar" cambias su rol y sus áreas. El nombre, el email y la contraseña se cambian en Effetá Apps, no aquí.',
      },
      {
        target: '[data-tour="users-table"]',
        title: 'Sin acceso y sin áreas',
        content:
          '"Sin acceso" marca a quien todavía no aceptó la invitación de Effetá Apps o perdió el acceso; en esas filas aparece "Dar acceso". "Sin áreas" marca a quien no ve el catálogo porque no tiene áreas asignadas. Las invitaciones las manda Effetá Apps: si a alguien no le llegó, la reenvía quien administra Effetá Apps.',
      },
    ],
  },
  {
    id: 'create',
    label: 'Dar acceso',
    steps: [
      {
        target: '[data-tour="users-new"]',
        title: 'Dar acceso',
        content:
          'Nombre, email y rol. La persona entra con su cuenta de Effetá Apps; si no tiene una, Effetá Apps se la crea y le manda un correo para activarla.',
      },
    ],
  },
];

export const usersNewSections: TourSection[] = [
  {
    id: 'form',
    label: 'Dar acceso al PIM',
    steps: [
      {
        target: '[data-tour="user-new-form"]',
        title: 'Datos de la persona',
        content:
          'Nombre, apellido, email, rol y áreas. No se define contraseña: la persona entra con su cuenta de Effetá Apps. Al terminar verás si Effetá Apps le mandó el correo de invitación; si no salió, pide a quien administra Effetá Apps que lo reenvíe.',
      },
    ],
  },
];

export const usersDetailSections: TourSection[] = [
  {
    id: 'form',
    label: 'Datos de la persona',
    steps: [
      {
        target: '[data-tour="user-detail-form"]',
        title: 'Datos de la persona',
        content:
          'Nombre y email, de solo lectura: se cambian en Effetá Apps. Más abajo cambias el rol (le llega en 15 minutos como mucho) y las áreas.',
      },
    ],
  },
  {
    id: 'danger-zone',
    label: 'Quitar acceso',
    steps: [
      {
        target: '[data-tour="user-detail-delete"]',
        title: 'Acceso al PIM',
        content:
          'Quitar acceso cierra sus sesiones y le quita el acceso en Effetá Apps. La persona no se borra: conserva sus áreas y su historial, y se le puede dar acceso de nuevo. No puedes quitarte el acceso a ti mismo.',
      },
    ],
  },
];
